import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EnterpriseAiSvg = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#eai-clip0)",
                children: [
                    /*#__PURE__*/ _jsx("rect", {
                        width: "24",
                        height: "24",
                        rx: "5",
                        fill: "#AAACEF"
                    }),
                    /*#__PURE__*/ _jsxs("g", {
                        filter: "url(#eai-filter0)",
                        children: [
                            /*#__PURE__*/ _jsx("g", {
                                clipPath: "url(#eai-paint0-clip)",
                                children: /*#__PURE__*/ _jsx("g", {
                                    transform: "matrix(0 0.013751 -0.013751 0 11.876 11.876)",
                                    children: /*#__PURE__*/ _jsx("foreignObject", {
                                        x: "-1050.82",
                                        y: "-1050.82",
                                        width: "2101.65",
                                        height: "2101.65",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            xmlns: "http://www.w3.org/1999/xhtml",
                                            style: {
                                                background: "conic-gradient(from 90deg, rgb(129,129,255) 0deg, rgb(129,129,255) 56.38deg, rgb(51,219,219) 149.98deg, rgb(51,213,142) 191.38deg, rgb(255,214,51) 230.98deg, rgb(252,82,125) 308.38deg, rgb(129,129,255) 360deg)",
                                                height: "100%",
                                                width: "100%",
                                                opacity: 1
                                            }
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("rect", {
                                width: "27.502",
                                height: "27.502",
                                transform: "translate(-1.875 -1.875)",
                                fill: "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("g", {
                        clipPath: "url(#eai-clip1)",
                        children: [
                            /*#__PURE__*/ _jsx("rect", {
                                x: "-0.000488281",
                                y: "-0.498962",
                                width: "24",
                                height: "24",
                                rx: "5",
                                fill: "#AAACEF"
                            }),
                            /*#__PURE__*/ _jsxs("g", {
                                filter: "url(#eai-filter1)",
                                children: [
                                    /*#__PURE__*/ _jsx("g", {
                                        clipPath: "url(#eai-paint1-clip)",
                                        children: /*#__PURE__*/ _jsx("g", {
                                            transform: "matrix(0 0.013751 -0.013751 0 11.8755 11.377)",
                                            children: /*#__PURE__*/ _jsx("foreignObject", {
                                                x: "-1050.82",
                                                y: "-1050.82",
                                                width: "2101.65",
                                                height: "2101.65",
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    xmlns: "http://www.w3.org/1999/xhtml",
                                                    style: {
                                                        background: "conic-gradient(from 90deg, rgb(129,129,255) 0deg, rgb(129,129,255) 56.38deg, rgb(51,219,219) 149.98deg, rgb(51,213,142) 191.38deg, rgb(255,214,51) 230.98deg, rgb(252,82,125) 308.38deg, rgb(129,129,255) 360deg)",
                                                        height: "100%",
                                                        width: "100%",
                                                        opacity: 1
                                                    }
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("rect", {
                                        width: "27.502",
                                        height: "27.502",
                                        transform: "translate(-1.87549 -2.37396)",
                                        fill: "none"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("g", {
                                filter: "url(#eai-filter2)",
                                children: /*#__PURE__*/ _jsx("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M12.581 18.9286C12.3261 19.0265 12.0431 19.0265 11.7883 18.9286L11.0794 18.6586C9.2864 17.9723 7.74622 16.768 6.6612 15.204C5.57619 13.6399 4.9971 11.7893 5.00001 9.89521V7.16007C5.00001 6.87607 5.25138 6.6588 5.53469 6.67876C6.71698 6.76207 7.90537 6.57236 9.00408 6.12161C10.0677 5.68527 11.014 5.01793 11.7742 4.17268C11.9869 3.93615 12.3718 3.94416 12.577 4.18719C14.0075 5.88104 16.1616 6.71937 18.8699 6.64582C19.1401 6.63848 19.3692 6.85144 19.3692 7.12172V9.89521C19.3721 11.7893 18.793 13.6399 17.708 15.204C16.623 16.768 15.0828 17.9723 13.2898 18.6586L12.581 18.9286ZM14.9215 10.4652C15.1603 10.1605 15.1068 9.71994 14.8021 9.48118C14.4974 9.24244 14.0568 9.29592 13.818 9.60065L12.0217 11.8934L11.16 11.3189C10.8379 11.1042 10.4027 11.1912 10.188 11.5133C9.97325 11.8354 10.0603 12.2706 10.3824 12.4853L11.7843 13.4199C12.0891 13.6231 12.4989 13.5573 12.7248 13.269L14.9215 10.4652Z",
                                    fill: "white"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("filter", {
                        id: "eai-filter0",
                        x: "-4.275",
                        y: "-4.275",
                        width: "32.302",
                        height: "32.302",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ _jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "1.2",
                                result: "effect1_foregroundBlur"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("clipPath", {
                        id: "eai-paint0-clip",
                        children: /*#__PURE__*/ _jsx("rect", {
                            width: "27.502",
                            height: "27.502",
                            transform: "translate(-1.875 -1.875)"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("filter", {
                        id: "eai-filter1",
                        x: "-4.27549",
                        y: "-4.77396",
                        width: "32.302",
                        height: "32.302",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ _jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "1.2",
                                result: "effect1_foregroundBlur"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("clipPath", {
                        id: "eai-paint1-clip",
                        children: /*#__PURE__*/ _jsx("rect", {
                            width: "27.502",
                            height: "27.502",
                            transform: "translate(-1.87549 -2.37396)"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("filter", {
                        id: "eai-filter2",
                        x: "2.73753",
                        y: "2.87071",
                        width: "18.8941",
                        height: "19.527",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ _jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ _jsx("feOffset", {
                                dy: "1.13318"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "1.13124"
                            }),
                            /*#__PURE__*/ _jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("clipPath", {
                        id: "eai-clip0",
                        children: /*#__PURE__*/ _jsx("rect", {
                            width: "24",
                            height: "24",
                            rx: "5",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ _jsx("clipPath", {
                        id: "eai-clip1",
                        children: /*#__PURE__*/ _jsx("rect", {
                            x: "-0.000488281",
                            y: "-0.498962",
                            width: "24",
                            height: "24",
                            rx: "5",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
export default EnterpriseAiSvg;
